export default "../css/f4d7dbcc64e1b37e5a8c421930cd9eb1.ttf";